exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".h-90vh[data-v-cf3deb5a] {\n  height: 90vh;\n}\n", ""]);

// exports
